import { Box, Grid, GridItem, Stack, Text } from "@chakra-ui/react";
import React from "react";
import IconText from "./IconText";
import ShipTruck from "../../../assets/jewellery/ShipTruck";
import Returns from "../../../assets/jewellery/Returns";
import Finance from "../../../assets/jewellery/Finance";
import Resize from "../../../assets/jewellery/Resize";

export default function WeCare() {
  const props = {
    flexDirection: "column",
    as: "",
  };

  return (
    <Stack align="center" bg="#E0DBD475" py={8} px={4}>
      <Text fontWeight="thin" fontSize="2xl">
        We care
      </Text>
      <Text
        fontWeight="thin"
        fontSize={{ base: "sm", sm: "xl" }}
        maxW="4xl"
        textAlign="center"
      >
        Our shopping experience is carefully designed with you in mind.
        Stress-free from start to finish with complimentary, no-hassle
        services—and that's our promise.
      </Text>

      <Grid templateColumns="repeat(2, 1fr)" pos="relative" gap={4} mt={5}>
        <IconText
          icon={<ShipTruck w={{ base: "30px", sm: "48px", md: "52px" }} />}
          text="2-Day Insured Shipping"
          props={props}
        />
        <IconText
          icon={<Returns w={{ base: "30px", sm: "48px", md: "52px" }} />}
          text="30-Day Returns & Exchanges"
          props={props}
        />

        <GridItem colSpan={2}>
          <Box bg="#999" h="1px" />
        </GridItem>
        <Box
          bg="#999"
          w="1px"
          pos="absolute"
          h="full"
          left="50%"
          transform="translateX(-8px)"
        />

        <IconText
          icon={<Finance w={{ base: "30px", sm: "48px", md: "52px" }} />}
          text="Financing Available"
          props={props}
        />
        <IconText
          icon={<Resize w={{ base: "30px", sm: "48px", md: "52px" }} />}
          text="Ring Resizing & Engraving"
          props={props}
        />
      </Grid>
    </Stack>
  );
}
